import { render, staticRenderFns } from "./video-list-item.vue?vue&type=template&id=7037e8ec&scoped=true&"
import script from "./video-list-item.vue?vue&type=script&lang=js&"
export * from "./video-list-item.vue?vue&type=script&lang=js&"
import style0 from "./video-list-item.vue?vue&type=style&index=0&id=7037e8ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7037e8ec",
  null
  
)

export default component.exports